/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { FaLink } from 'react-icons/fa'

import AssetTableCell from './AssetTableCell'

type AssetNameColProps = {
  name: string
  umd?: string
  isShared?: boolean
}

const AssetNameCol: React.FC<AssetNameColProps> = ({ name, umd, isShared }) => {
  return (
    <div className="px-2 w-full">
      <AssetTableCell tooltip={umd}>
        <span className="inline-flex items-center gap-1">
          {name}
          {isShared && <FaLink className="shrink-0 text-xs" title="Shared asset" aria-label="Shared asset" />}
        </span>
      </AssetTableCell>
    </div>
  )
}

export default AssetNameCol
